import axios from "axios";
import axiosInstance from "./axiosInstance";

// Get all paystubs for a specific employee
export const getPaystubs = (companyId, employeeId) => {
  return axios.get(
    `https://www.zapendhub.com/api/companies/${companyId}/employees/${employeeId}/paystubs`
  );
};

// Get paystub by ID (if needed)
export const getPaystubById = (companyId, employeeId, payrollId) => {
  return axiosInstance.get(
    `/companies/${companyId}/employees/${employeeId}/paystubs/${payrollId}`
  );
};

// Download or export a paystub
export const downloadPaystub = (companyId, employeeId, payrollId) => {
  return axiosInstance.get(
    `/companies/${companyId}/employees/${employeeId}/paystubs/${payrollId}/download`,
    {
      responseType: "blob",
    }
  );
};
